export const ENDPOINT_BASE = 'https://www.casumo.com/api/cmsquery/v2/root';

export const LINK_ACTIONS = {
    'cookie-settings': () => {
        const event = new CustomEvent('cookie-consent-settings:show');
        window.dispatchEvent(event);
    }
} as Record<string, () => void>;

export const CASUMO_EMAIL_ADDRESS = 'mailto:hey@casumo.com';

export const MARKET_SLUG_TO_WORDPRESS_MARKET: Record<string, string> = {
    en: 'en',
    row: 'en',
    rog: 'rg',
    fi: 'fi',
    sv: 'sv',
    es: 'es',
    no: 'no',
    ie: 'ie',
    on: 'on',
    'en-gb': 'gb',
    'en-ca': 'ca',
    'en-nz': 'nz'
};

export const PATHNAME_TO_SLUG_LOS: Record<string, string> = {
    '/en/': 'fabric.logged-out.fabric-pages.home-en',
    '/row/': 'fabric.logged-out.fabric-pages.home-row',
    '/rog/': 'fabric.logged-out.fabric-pages.home-rog',
    '/fi/': 'fabric.logged-out.fabric-pages.home-fi',
    '/sv/': 'fabric.logged-out.fabric-pages.home-sv',
    '/': 'fabric.logged-out.fabric-pages.home-es',
    '/no/': 'fabric.logged-out.fabric-pages.home-no',
    '/ie/': 'fabric.logged-out.fabric-pages.home-ie',
    '/on/': 'fabric.logged-out.fabric-pages.home-on',
    '/en-gb/': 'fabric.logged-out.fabric-pages.home-gb',
    '/en-ca/': 'fabric.logged-out.fabric-pages.home-ca',
    '/en-nz/': 'fabric.logged-out.fabric-pages.home-nz',
    '/en/slots/': 'fabric.logged-out.fabric-pages.slots-en',
    '/row/slots/': 'fabric.logged-out.fabric-pages.slots-row',
    '/rog/slots/': 'fabric.logged-out.fabric-pages.slots-rog',
    '/fi/slots/': 'fabric.logged-out.fabric-pages.slots-fi',
    '/sv/slots/': 'fabric.logged-out.fabric-pages.slots-sv',
    '/slots/': 'fabric.logged-out.fabric-pages.slots-es',
    '/no/slots/': 'fabric.logged-out.fabric-pages.slots-no',
    '/ie/slots/': 'fabric.logged-out.fabric-pages.slots-ie',
    '/on/slots/': 'fabric.logged-out.fabric-pages.slots-on',
    '/en-gb/slots/': 'fabric.logged-out.fabric-pages.slots-gb',
    '/en-ca/slots/': 'fabric.logged-out.fabric-pages.slots-ca',
    '/en-nz/slots/': 'fabric.logged-out.fabric-pages.slots-nz',
    '/en/live-casino/': 'fabric.logged-out.fabric-pages.live-en',
    '/row/live-casino/': 'fabric.logged-out.fabric-pages.live-row',
    '/rog/live-casino/': 'fabric.logged-out.fabric-pages.live-rog',
    '/fi/live-casino/': 'fabric.logged-out.fabric-pages.live-fi',
    '/sv/live-casino/': 'fabric.logged-out.fabric-pages.live-sv',
    '/casino-en-vivo/': 'fabric.logged-out.fabric-pages.live-es',
    '/no/live-casino/': 'fabric.logged-out.fabric-pages.live-no',
    '/ie/live-casino/': 'fabric.logged-out.fabric-pages.live-ie',
    '/on/live-casino/': 'fabric.logged-out.fabric-pages.live-on',
    '/en-gb/live-casino/': 'fabric.logged-out.fabric-pages.live-gb',
    '/en-ca/live-casino/': 'fabric.logged-out.fabric-pages.live-ca',
    '/en-nz/live-casino/': 'fabric.logged-out.fabric-pages.live-nz'
};

export const PATHNAME_TO_SLUG_LIS: Record<string, string> = {
    '/en/': 'fabric.logged-in.fabric-pages.home-___en',
    '/row/': 'fabric.logged-in.fabric-pages.home-___en',
    '/rog/': 'fabric.logged-in.fabric-pages.home-___en',
    '/fi/': 'fabric.logged-in.fabric-pages.home-fi_fi',
    '/sv/': 'fabric.logged-in.fabric-pages.home-se_sv',
    '/': 'fabric.logged-in.fabric-pages.home-es_es',
    '/no/': 'fabric.logged-in.fabric-pages.home-no_no',
    '/ie/': 'fabric.logged-in.fabric-pages.home-ie_en',
    '/on/': 'fabric.logged-in.fabric-pages.home-on_en',
    '/en-gb/': 'fabric.logged-in.fabric-pages.home-gb_en',
    '/en-ca/': 'fabric.logged-in.fabric-pages.home-ca_en',
    '/en-nz/': 'fabric.logged-in.fabric-pages.home-nz_en',
    '/en/slots/': 'fabric.logged-in.fabric-pages.slots-___en',
    '/row/slots/': 'fabric.logged-in.fabric-pages.slots-___en',
    '/rog/slots/': 'fabric.logged-in.fabric-pages.slots-___en',
    '/fi/slots/': 'fabric.logged-in.fabric-pages.slots-fi_fi',
    '/sv/slots/': 'fabric.logged-in.fabric-pages.slots-se_sv',
    '/slots/': 'fabric.logged-in.fabric-pages.slots-es_es',
    '/no/slots/': 'fabric.logged-in.fabric-pages.slots-no_no',
    '/ie/slots/': 'fabric.logged-in.fabric-pages.slots-ie_en',
    '/on/slots/': 'fabric.logged-in.fabric-pages.slots-on_en',
    '/en-gb/slots/': 'fabric.logged-in.fabric-pages.slots-gb_en',
    '/en-ca/slots/': 'fabric.logged-in.fabric-pages.slots-ca_en',
    '/en-nz/slots/': 'fabric.logged-in.fabric-pages.slots-nz_en',
    '/en/live-casino/': 'fabric.logged-in.fabric-pages.live-___en',
    '/row/live-casino/': 'fabric.logged-in.fabric-pages.live-___en',
    '/rog/live-casino/': 'fabric.logged-in.fabric-pages.live-___en',
    '/fi/live-casino/': 'fabric.logged-in.fabric-pages.live-fi_fi',
    '/sv/live-casino/': 'fabric.logged-in.fabric-pages.live-se_sv',
    '/casino-en-vivo/': 'fabric.logged-in.fabric-pages.live-es_es',
    '/no/live-casino/': 'fabric.logged-in.fabric-pages.live-no_no',
    '/ie/live-casino/': 'fabric.logged-in.fabric-pages.live-ie_en',
    '/on/live-casino/': 'fabric.logged-in.fabric-pages.live-on_en',
    '/en-gb/live-casino/': 'fabric.logged-in.fabric-pages.live-gb_en',
    '/en-ca/live-casino/': 'fabric.logged-in.fabric-pages.live-ca_en',
    '/en-nz/live-casino/': 'fabric.logged-in.fabric-pages.live-nz_en'
};
